import { render, staticRenderFns } from "./productReviewForSaleList.vue?vue&type=template&id=1cfc5010&scoped=true"
import script from "./productReviewForSaleList.vue?vue&type=script&lang=js"
export * from "./productReviewForSaleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc5010",
  null
  
)

export default component.exports